import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import About from "@/components/About";
import Experience from "@/components/Experience";
import FeaturedRole from "@/components/FeaturedRole";
import Capabilities from "@/components/Capabilities";
import Ecosystem from "@/components/Ecosystem";
import Leadership from "@/components/Leadership";
import Process from "@/components/Process";
import ToolsImpactEducation from "@/components/ToolsImpactEducation";
import Awards from "@/components/Awards";
import Portfolio from "@/components/Portfolio";
import ClientGrid from "@/components/ClientMarquee";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { useLenis } from "@/lib/scroll";

export default function HomePage() {
  useLenis();
  return (
    <div className="min-h-screen bg-parchment text-charcoal-900">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Experience />
        <FeaturedRole />
        <Capabilities />
        <Ecosystem />
        <Leadership />
        <Process />
        <ToolsImpactEducation />
        <Awards />
        <Portfolio />
        <ClientGrid />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
